// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__19_gX","topBottomGutter":"Layout_topBottomGutter__3HNdn"};